import { render, staticRenderFns } from "./merchant-detail.vue?vue&type=template&id=61e09f9a&"
import script from "./merchant-detail.vue?vue&type=script&lang=js&"
export * from "./merchant-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports